import request from '@/utils/request'

/**
 * 第一次提交简历调用的接口
 */
export function postVita (data) {
  return request({
    url: '/apply/resume',
    method: 'post',
    data: data
  })
}

/**
 * 更新简历
 */
export function putVita (data) {
  return request({
    url: '/apply/resume',
    method: 'put',
    data: data
  })
}

/**
 * 新增社招求职者信息
 */
export function postSocialVita (data) {
  return request({
    url: '/v2/social/resume/applicant',
    method: 'post',
    data: data
  })
}

/**
 * 更新社招求职者信息
 */
export function putSocialVita (data) {
  return request({
    url: '/v2/social/resume/applicant',
    method: 'put',
    data: data
  })
}

/**
 * 获取社招求职者信息（不需要传参），获取简历
 */
export function getSocialVita () {
  return request({
    url: '/v2/social/resume/applicant',
    method: 'get'
  })
}

/**
 * 获取社招求职者信息（需要传参 applyId），获取对应的简历
 */
export function getSocialVitaInfo (applyId) {
  return request({
    url: `/v2/social/resume/applicant`,
    method: 'get',
    params: { applyId }
  })
}

/**
 * 获取可投递简历数
 */
export function getVitaNum () {
  return request({
    url: '/apply/resume/number',
    method: 'get'
  })
}

/**
 * 获取简历信息（applyId作参数）
 */
export function getVitaInfo (applyId) {
  return request({
    url: `/apply/userResume?applyId=${applyId}`,
    method: 'get'
  })
}

/**
 * 获取简历信息（无参数）
 */
export function getVita () {
  return request({
    url: '/apply/userResume',
    method: 'get'
  })
}

/**
 * 是否投递过该岗位
 */
export function isApply (jobCode, recruitmentCategory) {
  return request({
    url: `/apply/resume/isApply`,
    method: 'get',
    params: { 'jobCode': jobCode, 'recruitmentCategory': recruitmentCategory }
  })
}

/**
 * 获取校招申请列表
 */
export function getApplyRecords () {
  return request({
    url: '/user-client/v1/applys',
    method: 'get'
  })
}

/**
 * 获取用户申请列表 recruitmentCategory : 1 校招，2 社招
 */
export function getUserApplyRecords2 (recruitmentCategory) {
  return request({
    url: '/user-client/v2/applys',
    method: 'get',
    params: { 'RecruitmentCategory': recruitmentCategory }
  })
}

export function getUserApplyRecords (params) {
  return request({
    url: '/user-client/v2/applys',
    method: 'get',
    params: params
  })
}

/**
 * 改变申请状态 -- 校招
 */
export function changeStatus (data) {
  return request({
    url: '/apply/resume/applyStatus',
    method: 'put',
    data: data
  })
}

/**
 * 改变申请状态 -- 社招
 */
export function changeSocialStatus (data) {
  const applyId = data.applyID || ''
  return request({
    url: `/v2/social/resume/applyStatus/${applyId}`,
    method: 'put',
    data: data
  })
}

/**
 * 放弃申请 校招
 */
export function removeApply (id, applyId) {
  return request({
    url: '/user-client/v1/apply',
    method: 'delete',
    params: {
      id,
      applyId
    }
  })
}

/**
 * 放弃申请 社招
 */
export function removeSocialApply (applyId) {
  return request({
    url: '/user-client/v1/social/apply',
    method: 'delete',
    params: {
      applyId
    }
  })
}

/**
 * 获取简历信息（无参数）
 */
export function getInterviewList (jobCode) {
  return request({
    url: `/apply/resume/locations?jobCode=${jobCode}`,
    method: 'get',
    data: jobCode
  })
}

/**
 * 获取面试安排
 */
export function getInterviewArangementList (id) {
  return request({
    url: '/v1/app/interview-room/room/query_list',
    method: 'post',
    data: { applicantId: id }
  })
}

/**
 * 获取面试安排详情
 */
export function getInterviewArangementInfo (id, roomId) {
  return request({
    url: '/v1/app/interview-room/room/detail',
    method: 'post',
    data: { applyId: id, interviewRoomId: roomId }
  })
}

/**
 * 检查是否需要定位
 */
export function getCheck () {
  return request({
    url: '/v1/portal/interviewLocation/check',
    method: 'get',
  })
}

/**
 * 签到
 */
export function sign (id, roomId) {
  return request({
    url: '/v1/app/interview-room/sign',
    method: 'post',
    data: { applyId: id, interviewRoomId: roomId }
  })
}

/**
 * 重新签到
 */
export function signAgain (id, roomId) {
  return request({
    url: '/v1/app/interview-room/sign_again',
    method: 'post',
    data: { applyId: id, interviewRoomId: roomId }
  })
}

/**
 * 获取学校列表
 */
export function getSchoolList (schoolName) {
  return request({
    url: `/apply/resume/schoolList?schoolName=${schoolName}`,
    method: 'get',
    data: schoolName
  })
}

/**
 * 上传文件
 */
export function uploadAttachment (data) {
  return request({
    url: '/apply/resume/uploadAttachment',
    method: 'post',
    data: data
  })
}

/**
 * 下载文件
 */
export function downloadAttachment (applyId, key, fileType) {
  return request({
    url: `/apply/resume/downloadAttachment?applyId=${applyId}&key=${key}&fileType=${fileType}`,
    method: 'get',
    data: { applyId, key, fileType }
  })
}

/**
 * 下载标准简历
 */
export function getDownloadResumePDF (applyId) {
  return request({
    url: `/apply/pdf/${applyId}`,
    method: 'get',
  })
}


/**
 * 身份证号是否能修改
 */
export function IdCardIsRedact (IDentificationNumber, CertificateType) {
  return request({
    url: `/apply/resume/IdCardIsRedact?IDentificationNumber=${IDentificationNumber}&CertificateType=${CertificateType}`,
    method: 'get'
  })
}

export function isIdCardIsRedact (IDentificationNumber, CertificateType) {
  return request({
    url: `/v2/social/apply/resume/IdCardIsRedact?IDentificationNumber=${IDentificationNumber}&CertificateType=${CertificateType}`,
    method: 'get'
  })
}

/**
 * 身份证号 新增证件号
 */
export function addIdCard (data) {
  return request({
    url: `/apply/resume/IDCard`,
    method: 'post',
    data: data
  })
}

/**
 * 身份证号 新增证件号
 */
export function addSocialIdCard (data) {
  return request({
    url: `/v2/social/apply/resume/IDCard`,
    method: 'post',
    data: data
  })
}

/**
 * 身份证号 更新证件号
 */
export function updateIdCard (applyId, data) {
  return request({
    url: `/apply/resume/IDCard/${applyId}`,
    method: 'put',
    data: data
  })
}

/**
 * 身份证号 更新证件号
 */
export function updateSocialIdCard (applyId, data) {
  return request({
    url: `/v2/social/apply/resume/IDCard/${applyId}`,
    method: 'put',
    data: data
  })
}

/**
 * 更新简历 v2
 */
export function putVitaV2 (data) {
  return request({
    url: 'apply/v2/resume',
    method: 'put',
    data: data
  })
}

/**
 * 更新教育背景接口
 */
export function putEducationBackground (applyId, list) {
  return request({
    url: `/apply/v2/resume/education-background/${applyId}`,
    method: "put",
    data: list,
  });
}

/**
 * 邮箱号获取验证码
 */
export function getEmailCode (email) {
  return request({
    url: '/deliver/v1/GetEmailCode',
    method: 'post',
    data: { email }
  })
}

/**
 * 获取地图秘钥 - Thunderforest
 */
export function getMapKey () {
  return request({
    url: '/v1/portal/interviewLocation/key',
    method: 'get'
  })
}

/**
 * 获取面试地点经纬度
 */
export function getInterviewLocationLngLat (name) {
  return request({
    url: '/v1/portal/interviewLocation/gh',
    method: 'post',
    data: { name }
  })
}


/**
 * 获取简历站点是否可以修改
 */
export function getResumeCanUpdateSite (applyId) {
  return request({
    url: '/v2/campus/resume/applicant/can_update_site',
    method: 'get',
    params: { applyId }
  })
}

// AI简历文件上传
export function aiRecognition (data) {
  return request({
    url: '/apply/resume/aiRecognition',
    method: 'post',
    data: data,
    timeout: 120000 // 设置2分钟超时
  })
}

// 查询AI识别简历解析结果
export function getAiRecognitionStatus(checksum, uploadTime) {
  return request({
    url: "/apply/resume/aiRecognition/status",
    method: "get",
    params: {checksum,uploadTime},
  });
}

